<template>
  <div class="mx-md-4 my-auto py-3">
    <span><slot name="head"></slot></span>
    <slot name="default"></slot>
    <ul class="my-auto">
      <li><a :href="github"><base-icon icon="github" :width="1.2" :height="1.2"></base-icon></a></li>
      <li><a :href="linkedin"><base-icon icon="linkedin-original" :width="1.2" :height="1.2"></base-icon></a></li>
      <li><a :href="twitter"><base-icon icon="twitter-original" :width="1.2" :height="1.2"></base-icon></a></li>
      <li><a :href="gmail"><base-icon icon="gmail" :width="1.2" :height="1.2"></base-icon></a></li>
    </ul>
  </div>
</template>

<script>
import BaseIcon from "../base/BaseIcon";
export default {
  name: "ContactInfo",
  components: {BaseIcon},
  computed: {
    gmail() {
      return this.$store.getters['contact/getGmail'];
    },
    linkedin() {
      return this.$store.getters['contact/getLinkedin'];
    },
    github() {
      return this.$store.getters['contact/getGithub'];
    },
    twitter() {
      return this.$store.getters['contact/getTwitter']
    }
  }
}
</script>

<style scoped>
div {
  max-height: 250px;
  width: 100%;
}
span {
  display: block;
}
li {
  display: inline;
  padding: 0 .4rem;
}
</style>